import { render, staticRenderFns } from "./settlementSettings.vue?vue&type=template&id=730e0c04&scoped=true&"
import script from "./settlementSettings.vue?vue&type=script&lang=js&"
export * from "./settlementSettings.vue?vue&type=script&lang=js&"
import style0 from "./settlementSettings.vue?vue&type=style&index=0&id=730e0c04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730e0c04",
  null
  
)

export default component.exports